import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaCartShopping } from "react-icons/fa6";
import { cartDrawerToggle } from "../redux/cartSlice";
import { useTheme } from "next-themes";

export default function CartIconButton({
  className = "",
  style = {},
  iconStyle = {},
  badgeStyle = {},
  theme = {},
  ...props
}) {
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  const { theme: globalTheme } = useTheme();

  // Merge theme from props and global
  const themeColors = {
    buttons: theme.buttons || globalTheme?.buttons || "#02f6d1",
    icons: theme.icons || globalTheme?.icons || "#02f6d1",
    background: theme.background || globalTheme?.background || "#fff",
    text: theme.text || globalTheme?.text || "#222",
  };

  return (
    <button
      onClick={() => dispatch(cartDrawerToggle())}
      className={
        "relative rounded-full p-2 shadow-md hover:scale-105 transition-transform border border-accent " +
        className
      }
      title="View Cart"
      style={{ borderColor: themeColors.buttons, background: themeColors.background, ...style }}
      aria-label="Cart"
      {...props}
    >
      <FaCartShopping style={{ color: themeColors.icons, width: 24, height: 24, ...iconStyle }} />
      {cartItems.length > 0 && (
        <span
          className="absolute -top-2 -right-2 text-xs font-bold rounded-full px-2 py-0.5"
          style={{ background: themeColors.buttons, color: themeColors.text, ...badgeStyle }}
        >
          {cartItems.length}
        </span>
      )}
    </button>
  );
}

